const studyAbroadData = {
  info: [
    {
      country: 'Argentina',
      number: 2,
      radius: 3,
      coordinates: [-34.59155872751775, -58.38028193994491],
      semesters: 'Fall',
      provider: 'UCEAP Programs',
      programs: 'Human Rights and Cultural Memory in Buenos Aires; Immigration and Identity: Asia in South America in Buenos Aires',
    },
    {
      country: 'Australia',
      number: 11,
      radius: 11,
      coordinates: [-25.78162461152006, 133.6582944424075],
      semesters: 'Fall and spring',
      provider: 'UCEAP Programs',
      programs: 'International Security in Canberra; University of Melbourne; University of Queensland; University of New South Wales in Sydney; Marine Biology & Terrestrial Ecology in Brisbane; University of Sydney',
    },
    {
      country: 'Barbados',
      number: 3,
      radius: 3,
      coordinates: [13.154682007451575, -59.55518808013399],
      semesters: 'Fall, spring and year',
      provider: 'UCEAP Programs',
      programs: 'University of the West Indies in Bridgetown',
    },
    {
      country: 'Belgium',
      number: 2,
      radius: 3,
      coordinates: [50.85137122854712, 4.358473802740423],
      semesters: 'Fall and spring',
      provider: 'UCEAP Programs',
      programs: 'Field Research & Internship in Brussels',
    },
    {
      country: 'Botswana',
      number: 1,
      radius: 3,
      coordinates: [-24.626759518619274, 25.919868906077216],
      semesters: 'Fall',
      provider: 'UCEAP Programs',
      programs: 'Community Public Health in Gaborone',
    },
    {
      country: 'Brazil',
      number: 3,
      radius: 3,
      coordinates: [-22.877399050204502, -43.225027800176385],
      semesters: 'Fall, spring and summer',
      provider: 'UCEAP Programs',
      programs: 'Brazilian Seminars in Rio de Janeiro; Pontifical Catholic University of Rio de Janeiro',
    },
    {
      country: 'Canada',
      number: 7,
      radius: 7,
      coordinates: [52.262125029465444, -98.87210889358307],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs and Berkeley Global Internships',
      programs: 'McGill University in Montreal; University of British Columbia in Vancouver; Global Internships in Toronto',
    },
    {
      country: 'Chile',
      number: 8,
      radius: 8,
      coordinates: [-33.44517235639519, -70.66626133011877],
      semesters: 'Fall, spring and year',
      provider: 'UCEAP Programs',
      programs: 'University of Chile in Santiago; Human Rights and Cultural Memory in Santiago; Pontifical Catholic University of Chile in Santiago; Social-Ecological Sustainability in Santiago and Villarica',
    },
    {
      country: 'China',
      number: 9,
      radius: 9,
      coordinates: [34.871546780187366, 117.43299612493395],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs',
      programs: 'Fudan University in Shanghai; Tsinghua University in Beijing; Chinese In Beijing; Shanghai Summer; Peking University in Beijing',
    },
    {
      country: 'Costa Rica',
      number: 2,
      radius: 3,
      coordinates: [10.286860711399925, -84.82226396027036],
      semesters: 'Fall and spring',
      provider: 'UCEAP Programs',
      programs: 'Tropical Biology and Conservation in Monteverde',
    },
    {
      country: 'Czech Republic',
      number: 5,
      radius: 5,
      coordinates: [50.08819740719098, 14.424480399925281],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs and Berkeley Global Internships',
      programs: 'Central European Studies in Prague; Summer Internship in Prague; Global Internships in Prague',
    },
    {
      country: 'Denmark',
      number: 7,
      radius: 7,
      coordinates: [55.70660147139214, 12.526207816914402],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs',
      programs: 'Aarhus University in Aarhus; University of Copenhagen; Copenhagen Business School Summer',
    },
    {
      country: 'Dominican Republic',
      number: 1,
      radius: 3,
      coordinates: [19.45237299581653, -70.69087377765932],
      semesters: 'Summer',
      provider: 'UCEAP Programs',
      programs: 'Community Public Health in Santiago',
    },
    {
      country: 'France',
      number: 22,
      radius: 22,
      coordinates: [48.85971972385999, 2.3405125263822315],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs, Berkeley Global Internships and Berkeley Summer Abroad',
      programs: 'Sciences Po Paris; University of Lyon; Field Research & Internship in Paris; Field Research & Internship in Strasbourg; French in Bordeaux; Global Internships in Paris; Food, History, and Culture in Paris; French in Paris; Social Justice and Activism; University of Bordeaux; French Language, Culture and Society in Paris; Global Cities Urban Realities in Paris',
    },
    {
      country: 'French Polynesia',
      number: 1,
      radius: 3,
      coordinates: [-17.53769686734654, -149.8287903621225],
      semesters: 'Spring',
      provider: 'Gump South Pacific Station',
      programs: 'Island Sustainability Program in Moorea',
    },
    {
      country: 'Germany',
      number: 12,
      radius: 12,
      coordinates: [52.522160772456466, 13.380861639884467],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs',
      programs: 'Technical University Berlin; Free University Berlin; Humboldt University Berlin; Summer Global Internship in Berlin',
    },
    {
      country: 'Ghana',
      number: 4,
      radius: 4,
      coordinates: [5.590175576462184, -0.18213319579083792],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs',
      programs: 'University of Ghana in Accra; Public Health and Society in Accra',
    },
    {
      country: 'Greece',
      number: 1,
      radius: 3,
      coordinates: [38.1248915466616, 23.773779336706443],
      semesters: 'Summer',
      provider: 'Berkeley Summer Abroad',
      programs: 'Mediterranean Nutrition and Food Systems in Chios',
    },
    {
      country: 'Hong Kong',
      number: 11,
      radius: 11,
      coordinates: [22.32524245322178, 114.177114913576],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs',
      programs: 'Chinese University of Hong Kong; University of Hong Kong; Hong Kong University of Science and Technology; Research in Hong Kong',
    },
    {
      country: 'Iceland',
      number: 3,
      radius: 3,
      coordinates: [64.13480998467907, -21.90050875668887],
      semesters: 'Fall, spring and year',
      provider: 'UCEAP Programs',
      programs: 'University of Iceland in Reykjavik',
    },
    {
      country: 'India',
      number: 1,
      radius: 3,
      coordinates: [28.673808805653927, 77.22845113713224],
      semesters: 'Summer',
      provider: 'UCEAP Programs',
      programs: 'New Delhi Summer',
    },
    {
      country: 'Ireland',
      number: 17,
      radius: 17,
      coordinates: [53.34839392798884, -6.285476213651397],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs, Berkeley Global Internships and Berkeley Summer Abroad',
      programs: 'University College Cork; Sport, History, and Cultural Identity in Dublin; Dublin Summer Chemistry; University College Dublin; Trinity College Dublin; Irish Parliament Internship in Dublin; Global Internships in Dublin',
    },
    {
      country: 'Israel',
      number: 6,
      radius: 6,
      coordinates: [32.3149814168729, 34.87527725134588],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs and Berkeley Global Internships',
      programs: 'Hebrew University of Jerusalem; Technion-Institute of Technology in Haifa; Global Internships in Haifa',
    },
    {
      country: 'Italy',
      number: 20,
      radius: 20,
      coordinates: [42.91993044075281, 12.440515960906351],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs',
      programs: 'Art, Food and Society in Rome; Made in Italy in Florence;  Sustainable Food Systems in the Mediterranean in Florence and Sicily; Bocconi University in Milan; Psychology & Cognitive Science in Padua; University of Bologna; Sociology in Rome',
    },
    {
      country: 'Japan',
      number: 16,
      radius: 16,
      coordinates: [35.664097599373534, 139.75077393235205],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs and Berkeley Global Internships',
      programs: 'STEM Research in Osaka; International Christian University in Tokyo; Global Internships in Tokyo; Global Studies in Yokohama; Waseda University in Tokyo; Japanese in Tokyo; Japanese in Kyoto; Hitotsubashi University in Tokyo; STEM Research in Tokyo; Engineering and Science in Sendai; Japanese in Osaka; Keio University in Tokyo',
    },
    {
      country: 'Jordan',
      number: 4,
      radius: 4,
      coordinates: [31.620905919688973, 36.21939014392051],
      semesters: 'Fall and spring',
      provider: 'UCEAP Programs',
      programs: 'Advanced Arabic Language in Amman; Middle East Studies in Amman',
    },
    {
      country: 'Korea',
      number: 9,
      radius: 9,
      coordinates: [37.56644854664684, 126.98070278745806],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs',
      programs: 'Korea University in Seoul; Seoul National University; Yonsei University in Seoul',
    },
    {
      country: 'Mexico',
      number: 7,
      radius: 7,
      coordinates: [19.429381694611443, -99.13188342617129],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs',
      programs: 'Global Health in Mexico in Puerto Escondido; Contemporary Mexico in Mexico City; Field Research in Mexico in various cities; National Autonomous University of Mexico in Mexico City; Leadership in Social Justice and Public Policy in Mexico City',
    },
    {
      country: 'Morocco',
      number: 1,
      radius: 3,
      coordinates: [33.95500930471582, -6.822790948243313],
      semesters: 'Fall',
      provider: 'UCEAP Programs',
      programs: 'Arabic Language and Culture in Rabat',
    },
    {
      country: 'Netherlands',
      number: 16,
      radius: 16,
      coordinates: [52.08815750260978, 5.352107137244269],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs',
      programs: 'Utrecht University; Wageningen University; Maastricht Summer; Psychology and Neuroscience in Maastricht; Business and Economics in Maastricht; Biological and Life Sciences in Maastricht; University College Maastricht',
    },
    {
      country: 'New Zealand',
      number: 11,
      radius: 11,
      coordinates: [-41.930736168177056, 173.1320703088473],
      semesters: 'Fall and spring',
      provider: 'UCEAP Programs',
      programs: 'Victoria University of Wellington; University of Waikato in Hamilton; University of Canterbury in Christchurch; Massey University in Wellington; University of Auckland; University of Otago in Dunedin',
    },
    {
      country: 'Norway',
      number: 4,
      radius: 4,
      coordinates: [59.9138056322884, 10.747895241982791],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs',
      programs: 'Oslo Summer; University of Oslo',
    },
    {
      country: 'Portugal',
      number: 2,
      radius: 3,
      coordinates: [40.01058073075671, -8.63082989215317],
      semesters: 'Summer',
      provider: 'Berkeley Summer Abroad',
      programs: 'Global Entrepreneurship and Innovation in Porto; Portuguese Literature in Translation in Azores',
    },
    {
      country: 'Russia',
      number: 6,
      radius: 6,
      coordinates: [59.936980877636394, 30.31839766866083],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs',
      programs: 'Russian Language in St. Petersburg; Russian Area Studies in St. Petersburg',
    },
    {
      country: 'Singapore',
      number: 10,
      radius: 10,
      coordinates: [1.327606509497668, 103.83873305976871],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs and Berkeley Global Internships',
      programs: 'Singapore University of Technology and Design; National University of Singapore; Summer Global Internship; Biodiversity; Global Internships; STEM Research',
    },
    {
      country: 'South Africa',
      number: 10,
      radius: 10,
      coordinates: [-33.984604422606495, 18.5614309758757],
      semesters: 'Fall, spring and summer',
      provider: 'UCEAP Programs',
      programs: 'Summer Global Internship in Cape Town; University of Cape Town',
    },
    {
      country: 'Spain',
      number: 15,
      radius: 15,
      coordinates: [40.414627914934044, -3.7044018270518726],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs, Berkeley Global Internships and Berkeley Summer Abroad',
      programs: 'Complutense University of Madrid; Sustainable Food Systems in the Mediterranean in Barcelona; University of Barcelona; Spanish in Madrid; Global Internships in Madrid; Python and Data Science in Madrid; Carlos III University of Madrid; Beyond Barcelona; 21st Century Barcelona',
    },
    {
      country: 'Sweden',
      number: 4,
      radius: 4,
      coordinates: [59.32413320915309, 18.06892483167806],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs and Berkeley Global Internships',
      programs: 'Lund University; Global Internships in Stockholm',
    },
    {
      country: 'Switzerland',
      number: 1,
      radius: 3,
      coordinates: [46.20469957389891, 6.145957104206219],
      semesters: 'Spring',
      provider: 'UCEAP Programs',
      programs: 'Global Studies in Geneva',
    },
    {
      country: 'Taiwan',
      number: 5,
      radius: 5,
      coordinates: [25.054544076513555, 121.51034974863747],
      semesters: 'Fall, spring and summer',
      provider: 'UCEAP Programs',
      programs: 'Chinese in Taipei; National Taiwan University in Taipei; Research in Taipei',
    },
    {
      country: 'Thailand',
      number: 6,
      radius: 6,
      coordinates: [13.752348245710866, 100.50548416681069],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs',
      programs: 'International Economics in Bangkok; Thammasat University in Bangkok; Public Health in Bangkok; Summer Internship in Bangkok',
    },
    {
      country: 'England, United Kingdom',
      number: 41,
      radius: 41,
      coordinates: [52.52639642960428, -0.9080894716849233],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs',
      programs: "University of Sussex; Environment and Sustainability, East Anglia in Norwich; Sotheby's Institute of Art in London; Business and Entrepreneurship in London; University of Kent in Canterbury; Global Cities Urban Realities in London; University of London, Queen Mary; London's Calling; Imperial College London; University of London, Royal Holloway; Summer in Cambridge; University College London; Summer in Sussex; University of Manchester; University of Bristol; London School of Economics; Summer in Oxford",
    },
    {
      country: 'Scotland, United Kingdom',
      number: 10,
      radius: 10,
      coordinates: [55.9326098838959, -3.757365853505754],
      semesters: 'Fall, spring, summer and year',
      provider: 'UCEAP Programs',
      programs: 'University of Edinburgh; University of Glasgow; Summer Research in Glasgow; University of St. Andrews; ',
    },
  ],

};

export default studyAbroadData;
